import { Plus } from 'assets/Icons'
import {
  Button,
  // ButtonPopover,
  // DropdownItem,
  // Typography,
} from 'components/common'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

// import styles from './NewDropdownButton.module.scss'
// import FileIcon from '../../../../../assets/Icons/FileIcon'
// import GuidelineIcon from '../../../../../assets/Icons/GuidelineIcon'
import { useIsBelowBreakpoint } from '../../../../../hooks'

const NewDropdownButton = (): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isTabLand = useIsBelowBreakpoint('tabLand')
  const isTabPort = useIsBelowBreakpoint('tabPort')

  const handleRedirect = (type: 'practice' | 'document') => () => {
    if (type === 'practice') {
      navigate('/new-guideline')
    }
    if (type === 'document') {
      navigate('/upload')
    }
  }

  return (
    <>
      {/*{isTabLand && (*/}
      <Button
        icon={<Plus />}
        variant={'primary'}
        color={'primary'}
        size={isTabLand ? 'x-small' : 'medium'}
        onClick={handleRedirect('practice')}
      >
        {isTabPort ? '' : t('practices.newGuideline')}
      </Button>
      {/*)}*/}
      {/*{!isTabLand && (*/}
      {/*  <ButtonPopover*/}
      {/*    buttonLabel={`${t('practices.new')}`}*/}
      {/*    buttonProps={{*/}
      {/*      variant: 'primary',*/}
      {/*      icon: <Plus />,*/}
      {/*    }}*/}
      {/*    anchorOrigin={{*/}
      {/*      horizontal: 'right',*/}
      {/*      vertical: 'bottom',*/}
      {/*    }}*/}
      {/*    transformOrigin={{*/}
      {/*      horizontal: 'right',*/}
      {/*      vertical: 'top',*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    <DropdownItem*/}
      {/*      onClick={handleRedirect('practice')}*/}
      {/*      icon={<GuidelineIcon />}*/}
      {/*      className={styles.listItem}*/}
      {/*    >*/}
      {/*      <Typography element="span">*/}
      {/*        {t('practices.newGuideline')}*/}
      {/*      </Typography>*/}
      {/*    </DropdownItem>*/}
      {/*    <DropdownItem*/}
      {/*      onClick={handleRedirect('document')}*/}
      {/*      icon={<FileIcon />}*/}
      {/*      className={styles.listItem}*/}
      {/*    >*/}
      {/*      <Typography element="span">{t('practices.newDocument')}</Typography>*/}
      {/*    </DropdownItem>*/}
      {/*  </ButtonPopover>*/}
      {/*)}*/}
    </>
  )
}

export default NewDropdownButton
